import { render, staticRenderFns } from "./file.vue?vue&type=template&id=532f86a6&scoped=true"
import script from "./file.vue?vue&type=script&lang=js"
export * from "./file.vue?vue&type=script&lang=js"
import style1 from "./file.vue?vue&type=style&index=1&id=532f86a6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532f86a6",
  null
  
)

export default component.exports